document.addEventListener("DOMContentLoaded", function () {
    const leftBar = document.querySelector(".cms-section .d-flex .left-bar");
    const header = document.querySelector("header"); // Adjust selector if needed
    let lastScrollTop = window.scrollY;

    function updateLeftBarPosition() {
        let currentScroll = window.scrollY;
        let headerHeight = header ? header.offsetHeight : 0;
        if(leftBar){
          if (currentScroll > lastScrollTop) {
            // Scrolling Down → Set top to 20px
            leftBar.style.top = "20px";
        } else {
            // Scrolling Up → Set top to header height
            if(headerHeight){
              leftBar.style.top = `${headerHeight + 20}px`;

            }
        }
        }

        lastScrollTop = currentScroll;
    }

    window.addEventListener("scroll", updateLeftBarPosition);

      const pageTitle = document.querySelector("head title")?.innerText.trim(); // Fetch page title from <head>
    
    if (pageTitle) {
        document.querySelectorAll("video-media video img").forEach(img => {
            if (!img.hasAttribute("alt")) {
                img.setAttribute("alt", `${pageTitle} video poster`);
                img.setAttribute("loading","lazy");
            }
        });
    }

    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener("click", function (event) {
            const hrefValue = this.getAttribute("href");

            if (hrefValue.includes("#")) {
                event.preventDefault(); // Prevent default jump behavior

                const [baseUrl, targetId] = hrefValue.split("#"); // Get page and section ID
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // If the section exists on the same page, scroll smoothly
                    const currentScrollY = window.scrollY;
                    const headerHeight = header ? header.offsetHeight : 0;
                    let targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

                    // If scrolling up, subtract header height
                    if (currentScrollY > targetPosition) {
                        targetPosition -= headerHeight;
                    }

                    window.scrollTo({
                        top: targetPosition,
                        behavior: "smooth"
                    });
                } else if (baseUrl) {
                    // If the link belongs to another page, navigate to it
                    window.location.href = baseUrl + "#" + targetId;
                }
            }
        });
    });

    // Handle scrolling when coming from another page
    if (window.location.hash) {
        const targetId = window.location.hash.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            setTimeout(() => {
                const headerHeight = header ? header.offsetHeight : 0;
                let targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
            }, 500); // Delay to ensure the element is loaded
        }
    }

    const backToTop = document.getElementById("backToTop");

    window.addEventListener("scroll", function () {
        if (window.scrollY > 300) { 
            backToTop.style.display = "block";
        } else {
            backToTop.style.display = "none";
        }
    });

    backToTop.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });

  // if (document.querySelector(".multi-grid-slider")) {
  //     // Initialize the Swiper
  //     var swiper = new Swiper(".multi-grid-slider", {
  //       slidesPerView: "auto",
  //       spaceBetween: 0,
  //       pagination: {
  //         el: ".swiper-pagination",
  //         clickable: true,
  //       },
  //       breakpoints: {
  //         575: {
  //           slidesPerView: 2,
  //         },
  //         1200: {
  //           slidesPerView: 3,
  //         },
  //         1500: {
  //           slidesPerView: 4,
  //         },
  //       },
  //     });

  // }

  if (document.querySelector(".video-multi-tab")) {
    // Initialize the Swiper
    var swiper = new Swiper(".video-multi-tab", {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }


  if (document.querySelector(".customer_review_slider")) {
    var swiper = new Swiper(".customer_review_slider", {
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1.9,
          },
          1200: {
            slidesPerView: 2.9,
          },
          1921: {
            slidesPerView: 3.9,
          },
        },
    });
  }

  const accordionIcons = document.querySelectorAll(".accordian_icon");

  accordionIcons.forEach(icon => {
    icon.addEventListener("click", () => {
      // Find the next ul element
      const menu = icon.nextElementSibling;

      if (menu && menu.tagName === "UL") {
        // Toggle the 'open' class
        menu.classList.toggle("open");

        // Change the icon to indicate the state
        if (menu.classList.contains("open")) {
          icon.innerHTML = `<img src="//www.usedcardboardboxes.com/cdn/shop/t/24/assets/minus.svg?v=182913605627412857901742370812" alt="" />`;
        } else {
          icon.innerHTML = `<img src="//www.usedcardboardboxes.com/cdn/shop/t/24/assets/plus.svg?v=53515978318432394731742370814" alt="" />`;
        }
      
      }
    });
  });

});

document.addEventListener("DOMContentLoaded", function () {
    const maxLength = 80; // Set character limit
    const paragraphs = document.querySelectorAll(".review-desc .content");

    paragraphs.forEach(paragraph => {
        let fullText = paragraph.innerHTML.trim();

        if (fullText.length > maxLength) {
            let truncatedText = fullText.substring(0, maxLength);
            let lastSpaceIndex = truncatedText.lastIndexOf(" ");
            truncatedText = truncatedText.substring(0, lastSpaceIndex);
            let moreText = fullText.substring(lastSpaceIndex);

            paragraph.innerHTML = `
                <span class="short-text">${truncatedText}</span>
                <span class="more-text">${moreText}</span>
                <button class="read-more-btn">... Read More</button>
            `;

            let button = paragraph.querySelector(".read-more-btn");
            let moreSpan = paragraph.querySelector(".more-text");
            let shortSpan = paragraph.querySelector(".short-text");

            button.addEventListener("click", function () {
                if (moreSpan.style.display === "none" || moreSpan.style.display === "") {
                    moreSpan.style.display = "inline";
                    button.textContent = "Read Less";
                } else {
                    moreSpan.style.display = "none";
                    shortSpan.style.display = "inline";
                    button.textContent = "... Read More";
                }
            });
        }
    });

    const quickBuyButtons = document.querySelectorAll(".quick-buy-modal-button");

  quickBuyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Check if "quick-buy-modal" exists in the DOM
      if (document.querySelector("quick-buy-modal")) {
        // Check if "pdp_custom.js" is already loaded
        if (!document.querySelector('script[src*="pdp_custom.js"]')) {
          const script = document.createElement("script");
          script.src = "//www.usedcardboardboxes.com/cdn/shop/t/24/assets/pdp_custom.js?v=24477693568990906641744025443"; // Shopify Liquid syntax
          script.async = true;
          document.body.appendChild(script);
        }
      }
    });
  });

});

document.querySelectorAll('.left-bar .scroll-link').forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();
        
        const targetClass = this.getAttribute('data-target'); // Get target section class
        
        // Remove 'clicked' class from all other links except this one
        document.querySelectorAll('.scroll-link').forEach(otherLink => {
            if (otherLink !== this) {
                otherLink.classList.remove('active');
            }
        });

        // Add 'active' class to the current active link
        this.classList.add('active');

        // Scroll to the target section
        const targetElement = document.querySelector('.' + targetClass);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    });
});

document.addEventListener("click", function (event) {
  // Check if the clicked element is inside a summary of an accordion
  const summary = event.target.closest(".accordion__disclosure summary");
  if (!summary) return;

  // Get the parent details element
  const clickedDetails = summary.closest(".accordion__disclosure");
  if (!clickedDetails) return;

  // Check if the clicked accordion is already open
  const isOpen = clickedDetails.hasAttribute("open");

  // Close all other accordions
  document.querySelectorAll(".accordion__disclosure[open]").forEach((details) => {
      if (details !== clickedDetails) {
          details.removeAttribute("open");
          details.setAttribute("aria-expanded", "false");
      }
  });

  // Toggle the clicked accordion
  if (!isOpen) {
      clickedDetails.setAttribute("open", "");
      clickedDetails.setAttribute("aria-expanded", "true");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const subscriptionSelect = document.querySelector(".subscription_option");
  const quantityInput = document.querySelector(".quantity_year");
 if(subscriptionSelect && quantityInput) { 
  subscriptionSelect.addEventListener("change", function () {
      if (this.value === "One Time") {
          quantityInput.disabled = true;
          quantityInput.value = "";
      } else {
          quantityInput.disabled = false;
      }
  });
}
});
